import React from 'react';
// import { homeObjOne, homeObjTwo, homeObjThree, homeObjFour } from './Data';
import {  Slider } from '../../components';
import images from '../../images';
import ContactForm from '../../components/Contact/ContactForm';
import Home from '../../components/InfoSection/Home';

function home() {
  return (
    <>
        {/* <Slider slides={images} /> */}
<Home/>
      {/* <InfoSection {...homeObjOne} /> */}
      {/* <Pricing /> */}
      {/* <ContactForm style={{ width:'1000px'}}/> */}
      
    </>
  );
}

export default home;
